module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('header', {
    staticClass: "col-xs-12 npd podcast__header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("RESULATADO DE BUSQUEDA")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 intbuscador",
    attrs: {
      "id": "#mybusqueda"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "name": "search",
      "type": "search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.banana($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "BUSCAR"
    }
  })]), _vm._v(" "), (_vm.resultados) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Resultados aproximados: " + _vm._s(Object.keys(_vm.resultados).length))]) : _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Resultados aproximados: Sin resultados ")])])])]), _vm._v(" "), (_vm.loaded == 'true') ? _c('div', [_c('section', {
    staticClass: "col-xs-12 block resultado"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.resultados), function(resultado) {
    return _c('div', {
      staticClass: "col-xs-12 npd resultado__item"
    }, [_c('figure', {
      staticClass: "col-xs-2 col-sm-3 col-md-1 npd"
    }, [(resultado.type == 'locutores') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'locutor',
          params: {
            locutor: resultado.slug
          }
        }
      }
    }, [(resultado.thumb) ? _c('img', {
      attrs: {
        "src": resultado.thumb,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    })]) : (resultado.type == 'programas') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'programa',
          params: {
            elprograma: resultado.slug
          }
        }
      }
    }, [(resultado.thumb) ? _c('img', {
      attrs: {
        "src": resultado.thumb,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    })]) : (resultado.type == 'post') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'post',
          params: {
            name: resultado.slug
          }
        }
      }
    }, [(resultado.thumb) ? _c('img', {
      attrs: {
        "src": resultado.thumb,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    })]) : _c('router-link', {
      attrs: {
        "to": {}
      }
    }, [(resultado.thumb) ? _c('img', {
      attrs: {
        "src": resultado.thumb,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    })])], 1), _vm._v(" "), _c('article', {
      staticClass: "col-xs-10 col-sm-4 col-md-11 resultado__desarrollo"
    }, [(resultado.type == 'locutores') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'locutor',
          params: {
            locutor: resultado.slug
          }
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(resultado.title))])]) : (resultado.type == 'programas') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'programa',
          params: {
            elprograma: resultado.slug
          }
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(resultado.title))])]) : (resultado.type == 'post') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'post',
          params: {
            name: resultado.slug
          }
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(resultado.title))])]) : _c('router-link', {
      attrs: {
        "to": {}
      }
    }, [_c('h3', [_vm._v(_vm._s(resultado.title))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 npd resultado__categoria"
    }, [(resultado.type !== 'post') ? _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("UpperFirst")(resultado.type)) + "\n                                    ")])]) : _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("UpperFirst")(resultado.category[0].cat_name)) + "\n                                    ")])])]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v("\n                                " + _vm._s(resultado.excerpt) + "\n                            ")])])], 1)])
  }))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00f4c9ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search.vue
// module id = 114
// module chunks = 0